<div class="mb-4 flex items-center justify-between rounded-xl border border-gray-6 bg-gray-a2 p-6 shadow-sm">
  <div class="flex items-center gap-4">
    <div class="flex h-12 w-12 items-center justify-center rounded-full bg-indigo-a1 text-indigo-9">
      <mat-icon>assessment</mat-icon>
    </div>
    <div>
      <h3 class="text-lg font-bold text-gray-12">
        <button
          type="button"
          class="text-left font-inherit text-lg font-bold text-gray-12 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-9 rounded cursor-pointer"
          (click)="debug.emit()"
          (keydown.enter)="debug.emit()"
          (keydown.space)="debug.emit(); $event.preventDefault()"
        >
          Résumé du bien
        </button>
      </h3>
      <p class="text-sm text-gray-11">Aperçu des surfaces et volumes</p>
    </div>
  </div>
  <div class="flex gap-8">
    <div class="flex flex-col items-center">
      <span class="text-2xl font-black text-indigo-9">{{ totalPieces() }}</span>
      <span class="text-xs font-medium tracking-wider text-gray-11 uppercase">Pièces</span>
    </div>
    <div class="flex flex-col items-center">
      <span class="text-2xl font-black text-indigo-9">{{ property().keyInfo.surface.habitable }}</span>
      <span class="text-xs font-medium tracking-wider text-gray-11 uppercase">m² hab.</span>
    </div>
    @if (property().keyInfo.surface.ground) {
      <div class="flex flex-col items-center">
        <span class="text-2xl font-black text-indigo-9">{{ property().keyInfo.surface.ground }}</span>
        <span class="text-xs font-medium tracking-wider text-gray-11 uppercase">m² au sol</span>
      </div>
    }
    @if (property().keyInfo.surface.land) {
      <div class="flex flex-col items-center">
        <span class="text-2xl font-black text-indigo-9">{{ property().keyInfo.surface.land }}</span>
        <span class="text-xs font-medium tracking-wider text-gray-11 uppercase">m² terrain</span>
      </div>
    }
    <div class="flex flex-col items-center">
      <span class="text-2xl font-black text-indigo-9">{{
        property().characteristics.interior.bedroom.length
      }}</span>
      <span class="text-xs font-medium tracking-wider text-gray-11 uppercase">Chambres</span>
    </div>
  </div>
</div>
